import { all, takeLatest, call, select, put } from 'redux-saga/effects';

import {
  types,
  queryOpenQuestionsFailure,
  queryOpenQuestionsSuccess,
  pickQuestionFailure,
  pickQuestionSuccess,
  declineQuestionFailure,
  declineQuestionSuccess,
  getOpenQuestionFilter,
} from '@coconut/services/redux/openQuestion';
import { getUserId } from '@coconut/services/redux/profile';
import { goToQuestionChatroomByID } from '@coconut/scenes/Chat/services/redux/selectQuestion';

import {
  getTutorQuestionsHistory,
  patchPickQuestion,
  patchDeclineQuestion,
} from '@coconut/services/apis/tutor';
import { pubnubSubscribe } from '@coconut/services/redux/pubnubQuestionList';

import { OPEN, ON_GOING, MATCHING } from '@coconut/constants/questions';
import { ONGOING } from '@coconut/constants/questionListTabNames';

import { tutorQuestions } from './questionList';

export function* queryOpenQuestionsFlow() {
  try {
    const abbr = yield select(getOpenQuestionFilter);
    const uid = yield select(getUserId);
    const {
      data: { questions },
    } = yield call(getTutorQuestionsHistory, {
      uid,
      statuses: [OPEN, MATCHING],
      abbr,
    });

    yield put(queryOpenQuestionsSuccess(questions));
    // subscribe all OPEN questions , in case students cancel question.
    const channels = questions.map((q) => q.pubnub_channel_name);
    yield put(pubnubSubscribe({ channels, userId: uid }));
  } catch (err) {
    yield put(queryOpenQuestionsFailure());
  }
}

export function* pickQuestionFlow(action) {
  try {
    const { questionId } = action.payload;
    const uid = yield select(getUserId);
    const {
      data: { question },
    } = yield call(patchPickQuestion, {
      uid,
      questionId,
    });

    const { aasm_state: state } = question;
    if (state === ON_GOING) {
      // free user, open chatroom directly and refresh question list
      yield call(tutorQuestions, ONGOING, uid);
      yield put(goToQuestionChatroomByID(questionId));
    }

    yield put(pickQuestionSuccess(questionId));
  } catch (err) {
    yield put(pickQuestionFailure());
  }
}

export function* declineQuestionFlow(action) {
  try {
    const { questionId } = action.payload;
    const uid = yield select(getUserId);
    yield call(patchDeclineQuestion, {
      uid,
      questionId,
    });

    yield put(declineQuestionSuccess(questionId));
  } catch (err) {
    yield put(declineQuestionFailure());
  }
}

export default function* () {
  yield all([
    takeLatest(types.QUERY_OPEN_QUESTIONS, queryOpenQuestionsFlow),
    takeLatest(types.PICK_QUESTION, pickQuestionFlow),
    takeLatest(types.DECLINE_QUESTION, declineQuestionFlow),
  ]);
}



// WEBPACK FOOTER //
// ./src/services/sagas/openQuestion.js